import React, { useState } from 'react'
import PropTypes from 'prop-types'

const DEFAULT_LIMIT = 5

// The first few items of a list that grows without bound (plan history,
// achievements, memories), with a toggle for the rest, so one long-time
// member doesn't stretch the page. `children` renders whichever items are
// visible; order `items` most relevant first.
const BoundedListComponent = ({ items, limit, noun, children }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const max = limit || DEFAULT_LIMIT
  const isBounded = items.length > max
  const visible = isBounded && !isExpanded ? items.slice(0, max) : items

  return (
    <>
      {children(visible)}
      {isBounded && (
        <button
          type="button"
          className="btn btn-link btn-sm px-0"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded
            ? 'Show fewer'
            : `Show all ${items.length}${noun ? ' ' + noun : ''}`}
        </button>
      )}
    </>
  )
}

BoundedListComponent.propTypes = {
  items: PropTypes.array.isRequired,
  limit: PropTypes.number,
  noun: PropTypes.string,
  children: PropTypes.func.isRequired
}

export default BoundedListComponent
